import { render, staticRenderFns } from "./SalaMunicipioHeader.vue?vue&type=template&id=76b78af8"
import script from "./SalaMunicipioHeader.vue?vue&type=script&lang=js"
export * from "./SalaMunicipioHeader.vue?vue&type=script&lang=js"
import style0 from "./SalaMunicipioHeader.vue?vue&type=style&index=0&id=76b78af8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports